import React from 'react';

const TrackSidebarLoading = () => (
    <>
        {[...Array(5)].map((_, index) => (
            <div key={index} className="rounded-lg bg-white cursor-pointer shadow-md overflow-hidden">
                {/* Row 1: Order ID + Badges + Action Buttons */}
                <div className="px-4 pt-3 pb-3 flex items-center flex-wrap gap-x-2.5">
                    <p className="text-sm font-medium h-5 custom-loading w-24">#WAL-TC3B-465</p>
                    <div className="flex flex-1 gap-x-2 gap-y-1">
                        <span className="custom-loading w-10 h-5 rounded-full">AA</span>
                        <span className="custom-loading w-16 h-5 rounded-full">AA</span>
                    </div>
                    <div className="flex items-center gap-x-1.5 flex-none custom-loading">
                        <span className="w-16 h-5 rounded-full">A</span>
                    </div>
                </div>

                {/* Row 3: Shipper / Consignee Box */}
                <div className="px-4 pb-3">
                    <div className="bg-gray50 border border-utilityGray200 rounded-lg px-3 py-3">
                        <div className="flex flex-col min-w-0">
                            <div className="flex items-center gap-x-1.5">
                                <span className="custom-loading w-40 h-[18px]">Montreal, QC H3B</span>
                            </div>
                            <span className="ml-[5px] w-[1px] border border-dashed border-gray400 h-[12px] opacity-80 custom-loading" />
                            <div className="flex items-center gap-x-1.5">
                                <span className="custom-loading w-36 h-[18px]">Toronto, ON M5H</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Row 4: Customer + Last Update */}
                <div className="px-4 pb-3 flex items-center justify-between gap-x-2">
                    <div className="flex items-center gap-x-2 min-w-0">
                        <span className="custom-loading w-5 h-5 rounded-md flex-none">A</span>
                        <span className="custom-loading w-24 h-4 truncate">Customer Name</span>
                    </div>
                    <div className="flex items-center gap-x-1.5 flex-none">
                        <span className="custom-loading w-20 h-4">Last updated</span>
                    </div>
                </div>
            </div>
        ))}
    </>
);

export default TrackSidebarLoading;
